import React from 'react';
import Row from './Row';

const Message = (props) => {
  const { i, rows, editMessageIndex, editRowIndex, editSlidePageIndex, currentEditSlidePage, effectFlag } = props
  // For spread object for Row component props
  const editIndexInfo = {
    editMessageIndex: editMessageIndex,
    editRowIndex: editRowIndex,
    editSlidePageIndex: editSlidePageIndex,
  }
  // console.log('editRowIndex :', editRowIndex);
  // console.log('editRowIndex-1 === i :', editRowIndex-1 === i);
  return (
    <div className="chatbot-message" style={i === 0 ? message_style : {...message_style, marginTop:15}}>
      <div className="chatbot-profile" style={profile_style}>

      </div>
      <div className="chatbot-message" style={message_con_style} onClick={e => e.stopPropagation()}>
        {
          rows ? ( 
            rows.map((row, i) => (
              <Row key={i} {...row} {...editIndexInfo} 
                currentEditSlidePage={currentEditSlidePage}
                effectFlag={(() => {
                  if (editRowIndex-1 === i && effectFlag) {
                    return true
                  }
                  return false
                })()} />
            ))
          ) : (
            <p> Rows is null </p>
          )
        }
      </div>
    </div>
  )
}

const message_style = {
  display: 'grid',
  gridTemplateColumns: "50px calc(100% - 50px)",
  // marginTop: 15,
}
const profile_style = {
  width: 45,
  height: 45,
  borderRadius: 27,
  background: "url('/images/chatbot_icon.png') 100% center no-repeat",
  backgroundSize: 45,
}
const message_con_style = {
  width: "100%",
  padding: 12,
  boxShadow: "0px 0.5px 2px 2px lightgray",
  backgroundColor: 'white',
  borderRadius: 9,
  borderTopLeftRadius: 0,
  fontSize: 15,
  marginTop: 5,
  cursor: 'default',
}

export default Message